import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import client from './apollo-client';
import { ApolloProvider } from 'react-apollo';
import { BrowserRouter } from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";

declare global {
  interface Window {
    _env_: {
      API_URL: string;
      PUBLIC_URL: string;
      USER_ENDPOINT: string;
      AUTH_ENDPOINT: string;
    }
  }
}

ReactDOM.render(
  <ApolloProvider client={client}>
    <BrowserRouter basename={window._env_.PUBLIC_URL}>
      <App />
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
